import { render, staticRenderFns } from "./ScreenshotsSliderComponent.vue?vue&type=template&id=6aaa2cb9"
import script from "./ScreenshotsSliderComponent.vue?vue&type=script&lang=ts"
export * from "./ScreenshotsSliderComponent.vue?vue&type=script&lang=ts"
import style0 from "./ScreenshotsSliderComponent.vue?vue&type=style&index=0&id=6aaa2cb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports